import { getCookie, setCookie } from './cookie';
import { getStorage, setStorage } from './storage';

const KEY_MEMBER_TOKEN = 'member_token';
const KEY_MEMBER_ID = 'member_id';
const KEY_REFERRAL_LINK_ID = '__rlid';

export function getToken () {
  return getCookie(KEY_MEMBER_TOKEN);
}

export function setToken (token, expires) {
  setCookie(KEY_MEMBER_TOKEN, token, expires ? { expires } : null);
}

export function getUid () {
  return Number(getStorage(KEY_MEMBER_ID) || getCookie(KEY_MEMBER_ID)) || 0;
}

export function setUid (uid, expires) {
  setStorage(KEY_MEMBER_ID, uid);
  setCookie(KEY_MEMBER_ID, uid, expires ? { expires } : null);
}

export function getReferralLinkId () {
  return getCookie(KEY_REFERRAL_LINK_ID);
}
